import React, { useState } from "react";
import {
  LayoutPanelLeft,
  UsersRound,
  Database,
  House,
  ChevronDown,
  BookOpen,
  UserCheck,
} from "lucide-react";
const baseUrl = process.env.REACT_APP_API_BASE_URL?.split("/api")[0];
const AdminSidebar = ({ activeSection, onSelect}) => {
  const [adminOpen, setAdminOpen] = useState(false);

  const menuItems = [
    { id: "dashboard", label: "Dashboard", icon: <LayoutPanelLeft size={20} /> },
    { id: "userManagement", label: "Recruiter Management", icon: <UsersRound size={20} /> },
    { id: "broadbeanUsers", label: "Broadbean Users", icon: <UserCheck size={20} /> },
    { id: "entities", label: "Entities Management", icon: <Database size={20} /> },
  ];

  return (
    <div className="bg-white/95 backdrop-blur-sm py-8 p-3 h-full flex flex-col gap-4">
      {menuItems.map((item) => (
        <div
          key={item.id}
          onClick={() => item?.id && onSelect(item.id)}
          title={item.label}
          aria-label={item.label}
          className={`flex items-center justify-center w-10 h-10 text-xs rounded-full cursor-pointer transition-all duration-150 ${
            activeSection === item.id ? "bg-[#dcfce7] " : "hover:bg-[#f0fdf4]"
          }`}
        >
          {item.icon}
        </div>
      ))}

      {/* Administration dropdown */}
      {/* <div
        className={`flex items-center justify-center w-10 h-10 text-xs rounded-full cursor-pointer transition-all duration-150 ${
          adminOpen ? "" : "hover:bg-[#f0fdf4]"
        }`}
        onClick={() => setAdminOpen((s) => !s)}
        title="Administration"
        aria-label="Administration"
      >
        <div className="flex flex-col items-center justify-center gap-0">
          <House size={18} />
          <ChevronDown size={12} className={`${adminOpen ? "rotate-180" : ""} transition-transform mt-1`} />
        </div>
      </div> */}
{/* 
      {adminOpen && (
        <div className="flex flex-col gap-2 items-center">
          <button
            type="button"
            onClick={() => window.open(`${baseUrl+'/docs'}`, "_blank", "noopener,noreferrer")}
            className="p-2 rounded-full w-10 h-10  hover:bg-[#f0fdf4] flex items-center justify-center"
            title="API"
            aria-label="API"
          >
            <BookOpen size={16} />
          </button>
        </div>
      )} */}
    </div>
  );
};

export default AdminSidebar;
